/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, g as getElement } from './index-ef0fa435.js';

const rangeCss = "slot-fb[hidden],slot[hidden]{display:initial !important}.center{text-align:center}.center lar-button{margin-bottom:0.5rem}";

const LarvaRangeNode = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.output = createEvent(this, "output", 7);
    this.request = createEvent(this, "request", 7);
    this.icon = 'security';
    this.color = 'primary';
    this.colorModal = undefined;
    this.colorInputs = undefined;
    this.colorIconSmall = undefined;
    this.disableQuickActions = false;
    this.hideTitles = undefined;
    this.supTitle = undefined;
    this.subTitle = undefined;
    this.log = false;
    this.mainTitle = undefined;
    this.nodeSize = 'default';
    this.checked = false;
    this.value = 0;
    this.step = 1;
    this.min = 0;
    this.max = 100;
    this.loading = true;
  }
  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node');
    this.output.emit({}); // getFullState
  }
  /**
   * Larva error input
   */
  async error(data) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
    // revert last switch back if error response
    this.checked = !this.checked;
  }
  changeToggle() {
    this.checked = Boolean(this.value);
  }
  /**
   * Larva input message
   */
  async input(data) {
    let value = parseFloat(data.value);
    if (isNaN(value)) {
      console.error(`lar-range receuived invalid message: ${JSON.stringify(data)}`);
      value = 0;
    }
    if (data.step) {
      const step = parseFloat(data.step);
      this.step = isNaN(step) ? this.step : step;
    }
    if (data.min) {
      const min = parseFloat(data.min);
      this.min = isNaN(min) ? this.min : min;
    }
    if (data.max) {
      const max = parseFloat(data.max);
      this.max = isNaN(max) ? this.max : max;
    }
    this.value = value;
    this.loading = false;
  }
  handleChange(value) {
    this.value = value;
  }
  handleChangeToggle(value) {
    if (value === this.checked) {
      return;
    }
    if (value) {
      this.value = this.max;
    }
    else {
      this.value = this.min;
    }
    this.handleBlur();
  }
  handleBlur() {
    if (!Number.isNaN(this.value) && this.loading === false) {
      this.loading = true;
      this.output.emit(this.value);
    }
  }
  render() {
    const componentProps = {
      onButtonclick: () => this.handleChangeToggle(!this.checked),
      onLarchange: (ev) => this.handleChange(ev.detail.value),
      onLarblur: () => this.handleBlur(),
      buttonValue: this.checked ? 'onoff.switchoff' : 'onoff.switchon',
      disabled: this.loading,
      color: this.colorInputs || this.color,
      value: this.value,
      min: this.min,
      max: this.max,
      step: this.step
    };
    return [
      h("lar-node", { value: String(this.value || 0), hideTitles: this.hideTitles, icon: this.icon, color: this.color, supTitle: this.supTitle, mainTitle: this.mainTitle, subTitle: this.subTitle, colorModal: this.colorModal, colorInputs: this.colorInputs, colorIconSmall: this.colorIconSmall, loading: this.loading, log: this.log, nodeSize: this.nodeSize, component: "range-content", componentProps: componentProps }, this.disableQuickActions === false &&
        h("lar-toggle", { slot: "titles", onLarchange: ev => this.handleChangeToggle(ev.detail.checked), checked: this.checked, color: this.colorInputs || this.color }), h("slot", null))
    ];
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["changeToggle"]
  }; }
};
LarvaRangeNode.style = rangeCss;

export { LarvaRangeNode as lar_range };

//# sourceMappingURL=lar-range.entry.js.map